export default __webpack_public_path__ + "static/media/GR00059-night.134c1d5a.svg";